module.exports = __webpack_public_path__ + "static/media/10.6942e136.jpg";